export default "__VITE_ASSET__DHu3A9OT__ 288w, __VITE_ASSET__BfJmGmFg__ 432w, __VITE_ASSET__DB1CT81A__ 576w";